import React from 'react';


function StatsPage() {
    return (
        <div></div>
    );
}

export default StatsPage;